import React from "react";
import { Table, ConfigProvider, Tag } from "antd";
import { AlertCircle } from "../../utils/icons";

const dataSource = [
  {
    key: "1",
    item: (
      <div>
        <h1>Weekly Quizzes</h1>
        <p>Complete all of the assignments in this group</p>
      </div>
    ),
    status: "-",
    due: "March 17",
    weight: "75 %",
    grade: "0 %",
  },
  {
    key: "2",
    item: (
      <div>
        <h1>Weekly Quizzes</h1>
        <p>Complete all of the assignments in this group</p>
      </div>
    ),
    status: "-",
    due: "March 17",
    weight: "62 %",
    grade: "0 %",
  },
  {
    key: "3",
    item: (
      <div>
        <h1>Weekly Quizzes</h1>
        <p>Complete all of the assignments in this group</p>
      </div>
    ),
    status: "-",
    due: "March 17",
    weight: "62 %",
    grade: "0 %",
  },
  {
    key: "4",
    item: (
      <div>
        <h1>Weekly Quizzes</h1>
        <p>Complete all of the assignments in this group</p>
      </div>
    ),
    status: "-",
    due: "March 17",
    weight: "62 %",
    grade: "0 %",
  },
  // Add more objects as needed
];

const columns = [
  {
    title: "Item",
    dataIndex: "item",
    key: "item",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Due",
    dataIndex: "due",
    key: "due",
  },
  {
    title: "Weight",
    dataIndex: "weight",
    key: "weight",
  },
  {
    title: "Grade",
    dataIndex: "grade",
    key: "grade",
  },
];

function GradesTable() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "white",
            rowHoverBg: "rgb(243 244 246)",
          },
        },
      }}
    >
      <div className="flex justify-between">
        <h1>Grades</h1> <AlertCircle />
      </div>
      <Table pagination={false} dataSource={dataSource} columns={columns} />
    </ConfigProvider>
  );
}

export default GradesTable;
